import { AppRoutes } from '@core';
import { TabsDataModel } from './tabs-data.interface';

export const tabsData: TabsDataModel[] = [
  {
    route: AppRoutes.DASHBOARD,
    name: 'Home',
    icon: 'assets/icons/v2/home.svg',
    id: AppRoutes.DASHBOARD
  },
  {
    route: AppRoutes.FIND_GAMES,
    name: 'Gierki',
    icon: 'assets/icons/v2/games.svg',
    id: AppRoutes.FIND_GAMES
  },
  {
    route: AppRoutes.MESSAGES,
    name: 'Wiadomości',
    icon: 'assets/icons/v2/messages.svg',
    id: AppRoutes.MESSAGES
  },
  {
    route: AppRoutes.PROFILE,
    name: 'Profil',
    icon: 'assets/icons/v2/profile.svg',
    id: AppRoutes.PROFILE
  }
];
